/*
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-03-24 16:07:46
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-02-11 10:14:08
 */
import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import global from '@/config/global'

// create an axios instance
const request = axios.create({
  baseURL: global.baseApi, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000 // request timeout
})

export const requestKdz = axios.create({
  baseURL: "", // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 15000 // request timeout
})

// request interceptor
request.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = store.getters.token
  }

  return config
})

// 防止多个并发请求同时触发时重复提示和重复跳转
let jwtExpiredHandling = false

// 登录凭证过期：警示并自动退出
function handleJwtExpired (data) {
  if (!data || String(data.status) !== '500' || !/jwt expired/i.test(data.message || '')) {
    return
  }
  if (jwtExpiredHandling) {
    return
  }
  jwtExpiredHandling = true

  if (Vue.prototype.$notify) {
    Vue.prototype.$notify({
      title: '登录失效',
      message: '登录已过期，请重新登录',
      type: 'warning',
      duration: 3000
    })
  }

  // 清除 token、用户信息及本地缓存
  store.commit('logout')

  // 跳转到登录页
  window.location.hash = '#/login'

  // 一段时间后允许再次处理，避免影响重新登录后的正常请求
  setTimeout(() => {
    jwtExpiredHandling = false
  }, 3000)
}

// response interceptor
request.interceptors.response.use(response => {
  const token = response.headers['right-token']
  token && store.commit('setToken', token)

  handleJwtExpired(response.data)

  return response.data
}, error => {
  // 兼容服务端以非 2xx 状态码返回的情况
  if (error.response) {
    handleJwtExpired(error.response.data)
  }

  return Promise.reject(error)
})

export default request

